import React from 'react';
import styles from './Spinner.css';

const spinner = () => (
    <div className={styles.Loader}>Loading...</div>
);

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js